import script from "./MyTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyTags.vue?vue&type=script&setup=true&lang=ts"

import "./MyTags.vue?vue&type=style&index=0&id=101df15a&lang=scss"

const __exports__ = script;

export default __exports__